exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-4cae0a18]{text-transform:uppercase;margin-left:-20px;padding-left:10px;font-weight:500}.panel-flat[data-v-4cae0a18]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cae0a18","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/exportOrder/addExportOrder.vue
// module id = 820
// module chunks = 0